// extracted by mini-css-extract-plugin
module.exports = {"payment-info":"payment-info__1Ra36","heading":"heading__3OUU7","card-number":"card-number__27In2","brand-icon":"brand-icon__ReWqK","card-number-text":"card-number-text__37R2d"};